<template>
  <div>
    <h1>Reset Password</h1>

    <p v-if="tokenStatus == 'checking'">
      Loading...
    </p>

    <form
      v-else-if="tokenStatus == 'valid'"
      @submit.prevent="submitForm"
    >
      <div
        v-if="formErrors.non_field_errors !== undefined"
        class="alert alert-danger"
        role="alert"
      >
        {{ formErrors.non_field_errors[0] }}
      </div>

      <div class="form-group">
        <label for="password1">Password</label>
        <input
          id="password1"
          v-model="formFields.password1"
          type="password"
          required
        >
        <div
          v-if="formErrors.password1 !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.password1[0] }}
        </div>
      </div>

      <div class="form-group">
        <label for="password2">Confirm password</label>
        <input
          id="password2"
          v-model="formFields.password2"
          type="password"
          required
        >
        <div
          v-if="formErrors.password2 !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.password2[0] }}
        </div>
      </div>

      <button
        type="submit"
        class="btn btn-primary"
        :disabled="formSubmitting"
      >
        <template v-if="formSubmitting">
          Resetting
          <spinner />
        </template>
        <template v-else>
          Reset
        </template>
      </button>
    </form>

    <div
      v-else-if="tokenStatus == 'error'"
      class="alert alert-danger"
      role="alert"
    >
      Unable to communicate with the server. Please check your connection and
      try again.
      <a
        href="javascript:void(0);"
        class="btn btn-outline-danger btn-sm"
        @click="checkEmailVerificationLink"
      >Try again</a>
    </div>

    <p
      v-else-if="tokenStatus == 'invalid'"
      class="alert alert-danger"
      role="alert"
    >
      The reset password link was invalid.
    </p>

    <p
      v-if="formSuccess"
    >
      Your password has been changed. Please
      <router-link :to="{name: 'login'}">
        log in.
      </router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tokenStatus: 'checking',
      formErrors: {},
      formSuccess: false,
      formSubmitting: false,
      formFields: {
        password1: '',
        password2: '',
      },
    };
  },
  mounted() {
    this.checkEmailVerificationLink();
  },
  methods: {
    async checkEmailVerificationLink() {
      this.tokenStatus = 'checking';

      const data = {
        token: this.token,
      };

      const responseData = await this.api({
        url: 'users/checkResetToken/',
        method: 'POST',
        json: data,
      });

      if (responseData.status === 200) {
        this.tokenStatus = responseData.body.valid ? 'valid' : 'invalid';
      } else {
        this.tokenStatus = 'error';
      }
    },
    async submitForm() {
      this.formErrors = {};
      this.formSubmitting = true;

      this.formFields.token = this.token;

      const responseData = await this.api({
        url: 'users/updatePassword/',
        method: 'POST',
        json: this.formFields,
      });

      this.formFields = {
        password1: '',
        password2: '',
      };

      this.formSubmitting = false;

      if (responseData.status === 200) {
        this.formSuccess = true;
      } else if (responseData.status === 400) {
        this.formErrors = responseData.body;
      } else {
        this.formErrors = {
          non_field_errors: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  form {
    max-width: 256px;
  }
</style>
